import axios from 'axios';
import { currentCompanyId, currentCompanyPresent } from 'utils/company';
import { authToken, authPresent } from 'utils/session';
import { clearSessionStorage } from 'utils/stateStorage';
import { buildURL } from './helpers';

const handleSuccess = ({ data, status }) => ({
  statusCode: status,
  body: data,
});

const onLoginUrl = () => {
  if (window.location.pathname === '/') {
    return true;
  }

  return false;
};

const handleFailure = (e) => {
  if (e.response.status === 401 && !onLoginUrl(e.request)) {
    // Since we don't have 'props.history' here,
    // we need to change 'window.location' manually
    clearSessionStorage();
    window.location.href = '/';
  } else {
    throw e;
  }
};

const buildHeaders = () => {
  const headers = [];

  if (authPresent()) {
    headers.push({ Authorization: `Bearer ${authToken()}` });
  }

  if (currentCompanyPresent()) {
    headers.push({ 'X-Company-ID': currentCompanyId() });
  }

  return Object.assign({}, ...headers);
};

const jsonApiHeader = { 'Content-Type': 'application/vnd.api+json' };

const dispatch = (method, endpoint, id = '', action = '', params = {}, data = {}, headers = {}) => axios({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  method,
  url: buildURL(endpoint, id, action, params),
  data,
  headers: {
    ...buildHeaders(),
    ...({ ...jsonApiHeader, ...headers }),
  },
})
  .then(handleSuccess)
  .catch(handleFailure);


const REST = {
  get: (endpoint, id, params, headers) => dispatch('get', endpoint, id, '', params, headers),
  getAction: (endpoint, id, action, params, headers) => dispatch('get', endpoint, id, action, params, headers),
  post: (endpoint, body, params, headers) => dispatch('post', endpoint, '', '', params, body, headers),
  patch: (endpoint, id, body, params, headers) => dispatch('patch', endpoint, id, '', params, body, headers),
  patchAction: (endpoint, id, action, body, params, headers) => dispatch('patch', endpoint, id, action, params, body, headers),
  delete: (endpoint, id, headers) => dispatch('delete', endpoint, id, headers),
};

export default REST;
